module.exports = __webpack_public_path__ + "static/media/lg.4fe6f9ca.ttf";